import ZariPortlet from './portlet'
import PortletHeader from './header'
import PortletBody from './body'
import PortletFooter from './footer'

ZariPortlet.Header = PortletHeader
ZariPortlet.Body = PortletBody
ZariPortlet.Footer = PortletFooter

export default ZariPortlet
